<template>
  <div class="protocol-update">
    <div class="ln-modal">
      <div
        class="van-overlay"
        style="z-index: 1999; background-color: rgba(0, 0, 0, 0)"
      ></div>
      <div class="dialog">
        <div class="dialog_proto">

         <!-- 第一步 -->
          <div v-if="step_a">
              <div class="dialog_proto_con account_a">
                <van-icon name="arrow-left" style="font-size:16px" @click="closeDelAcc" />
                <div class="account_tit" style="margin-top:-15px;">删除账户说明</div>
                <p>
                    尊敬的用户，为保证您的账户和财产安全，在您注销账户前，请确保已满足以下条件：
                </p>
                <p>1、账户处于安全状态：近两周内修改密码、密保等账户资料修改记录，账户正常使用且无被封、被盗等风险；</p>
                <p>2、账户无任何未完成状态订单：包括购买和消费道具、皮肤以及运营活动；</p>
                <p>3、账户无任何纠纷：包括投诉举报、被投诉举报、仲裁、诉讼等纠纷。</p>
            </div>
            <van-col style="width:100%;text-align: center;">
                <Button
                    type="info"
                    style="width: 90%"
                    size="small"
                    @click="nextStep"
                    native-type="button"
                >
                    继续
                </Button>
                </van-col>
          </div>

          <!-- 第二步-->
          <div v-if="step_b">
              <div class="dialog_proto_con account_a">
                <!-- <van-icon name="arrow-left" style="font-size:16px" @click="closeDelAcc" /> -->
                <van-icon name="arrow-left" style="font-size:16px;position:absolute;left:1px;top:10px" @click="backFir" />
                <!-- <div class="account_tit">删除账户说明</div> -->
                <p style="margin:0;padding:0">
                    尊敬的用户，在您正式开始删除账户流程之前，请您务必详细阅读并同意以下《删除账户协议》。当您开始删除账户流程，或您勾选同意本协议并进行下一步操作，即视为您已经同意和遵守本协议全部内容：
                </p>
                <div class="account_tit">《删除账户协议》</div>
                <p style="margin:0;padding:0">注销本产品或服务的账号后，除法律法规或本协议另有规定外，您在该账户下的个人信息将全部进行删除处理，且此前已关联该账号的相关产品与服务将不再关联。账号一旦注销完成，将无法恢复，您无法再检索、访问、获取继续使用和找回，也无权要求我们找回已删除的账户信息：包括但不限于头像、昵称、充值和消费记录、好友关系、等级、聊天记录等。</p>
            </div>
            <div style="margin-left:16px;margin-top:5px;"><van-checkbox v-model="accChecked" shape="square"  icon-size="16px" style="font-size:13px;">我已详细阅读并同意《删除账户协议》</van-checkbox></div>
            <van-col style="width:100%;padding-bottom:10px;margin-top:6px;text-align: center;">
                <Button
                    style="width: 90%"
                    type="info"
                    size="small"
                    @click="nextStepb"
                    native-type="button"
                >
                    继续
                </Button>
                </van-col>
          </div>

          <!-- 第三步 -->
          <div v-if="step_c">
              <div class="dialog_proto_con account_a">
                <van-icon name="arrow-left" style="font-size:16px;position:absolute;left:1px;top:10px" @click="backSec" />
                <!-- <van-icon name="arrow-left" style="font-size:16px" @click="closeDelAcc" /> -->
                <div>为防止误操作，请再次确认是否删除账户并确认删除后的影响。包括但不限于：</div>
                <p style="margin:0;padding:0">
                    1、除法律法规或本协议另有规定外，您在该账户下的个人信息将全部进行删除处理，且此前已关联该账号的相关产品与服务将不再关联。账号一旦注销完成，将无法恢复，您无法再检索、访问、获取继续使用和找回，也无权要求我们找回已删除的账户信息：包括但不限于头像、昵称、充值和消费记录、好友关系、等级、聊天记录等。
                </p>
                <p style="margin:0;padding:0">2、该账户下的相关收益也将会被删除。一旦您删除本账户，如账户下还存在相关收益或权益（包括在本产品使用期间已产生的及未来可能产生的收益），会视为您自愿放弃该等收益或权益，我们有权对该账户下的全部收益或权益做清除处理，因此产生的后果由您自行承担，您同意不会要求我们恢复或赔偿该等收益或权益。前述收益或权益包括但不限于：该账户下的会员权益、等级、优惠券、兑换券、虚拟道具及其他虚拟物品（如卡券、金币、钻石、道具及其他等）、已经购买的未到期的服务、已产生但未消耗完毕的其他收益或未来预期的收益或权益等</p>
                <p style="margin:0;padding:0">3、账户一旦注销，将无法恢复。且您无法再使用相同的账户注册本产品或服务的账户。</p>
            </div>
            <div style="margin-left:16px;margin-top:5px;"><van-checkbox v-model="conChecked" shape="square"  icon-size="16px" style="font-size:13px;">我确认已知悉相关内容并同意删除账户</van-checkbox></div>
            <van-col style="width:100%;padding-bottom:10px;margin-top:6px;text-align: center;">
                <Button
                    type="info"
                    style="width: 90%"
                    size="small"
                    @click="nextStepc"
                    native-type="button"
                >
                    确认删除
                </Button>
                </van-col>
          </div>

          <!-- 第四步 -->
          <div v-if="step_d">
              <div class="dialog_proto_con account_a">
                <!-- <van-icon name="arrow-left" style="font-size:16px" @click="closeDelAcc" /> -->
                <div>当前账户将于17天后完成删除操作：</div>
                <p>1、账户将会彻底删除；</p>
                <p>2、删除后所有账户和资料都无法恢复；</p>
                <p>3、删除后无法再次使用此账户登录/注册。</p>
            </div>
            <van-col style="width:100%;margin-top:15px;text-align: center;">
                <Button
                    type="info"
                    style="width: 90%"
                    size="small"
                    @click="nextStepd"
                    native-type="button"
                >
                    确认
                </Button>
                </van-col>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Col, Row, Button, Dialog, Checkbox, Toast } from "vant";

export default {
  name: "ProtocolUpdate",
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Dialog.name]: Dialog,
    [Checkbox.name]: Checkbox,
    Button,
  },
  props: {
    // show:false,
  },
  data() {
    return {
        step_a: true,
        step_b: false,
        step_c: false,
        step_d: false,
        accChecked: false,
        conChecked: false
    };
  },
  methods: {
    rejectClick() {
      this.$emit('protocolClick',false)
    },
    sureAgreeClick() {
      this.$emit('protocolClick',true)
    },
    closeProto() {
      this.$refs.iframe.src = this.updateUrl;
    },
    nextStep() {
        this.step_a = false;
        this.step_b = true;
    },
    nextStepb() {
        if (!this.accChecked) {
            Toast.fail('请同意删除用户协议再进行下一步操作');
            return
        }
        this.step_b = false;
        this.step_c = true;
    },
    nextStepc() {
        if (!this.conChecked) {
            Toast.fail('请勾选已确认内容再进行下一步操作');
            return
        }
        this.step_c = false;
        this.step_d = true;
    },
    nextStepd() {
        this.$emit('backClick',false);
    },
    backFir() {
      this.step_a = true;
      this.step_b = false;
    },
    backSec() {
      this.step_b = true;
      this.step_c = false;
    },
    closeDelAcc() {
        this.$emit('backClick',false)
    },
  },
};
</script>

<style scoped lang="scss">
.dialog {
  position: fixed;
  width: 320px;
  // max-height: 320px;
  height: 100%;
  overflow: scroll;

  font-size: 16px;
  background: #f7fbfc;
  transition: all 0.3s;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2000;
}
.dialog_proto {
  // position: fixed;
  top: 0;
  left: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2000;
  // background: rgba(0, 0, 0, 0.4);
  background-color: #f6fcfa;
}
.dialog_proto_con {
  margin: 10px auto 0;
  width: 90%;
  height: 80%;
  background: #fff;
  border-radius: 5px;
  border: 1px solid #e2e2e2;
}
.account_a{font-size: 13px;text-align: left;padding: 0px;border: none;}
.account_a .account_tit{text-align: center;font-weight: bold;font-size: 14px;}
</style>
